import {ApplicationConfig,  provideZoneChangeDetection} from '@angular/core';
import {InMemoryScrollingOptions, provideRouter, withComponentInputBinding, withInMemoryScrolling} from '@angular/router';

import { routes } from './app.routes';
import {DatePipe} from "@angular/common";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {HttpErrorInterceptor} from "@shared/http-error.interceptor";
import {provideAnimations} from "@angular/platform-browser/animations";
import { provideToastr } from 'ngx-toastr';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled'
};
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withInMemoryScrolling(scrollConfig)),
    provideHttpClient(withInterceptors([HttpErrorInterceptor])),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-bottom-right',
      enableHtml: true,
      progressBar: true,
      preventDuplicates: true
    }),
    DatePipe
  ]
};
